import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { compose, withStateHandlers } from 'recompose';

const TooltipOnEllipsis = ({ showTooltip, setShowTooltip, component }) => {
  const tooltip = <Popover id='tooltip-on-ellipsis'>
    {component}
  </Popover>

  const isEllipsisActive = (e) => {
    return (e.offsetWidth < e.scrollWidth) || (e.offsetHeight < e.scrollHeight - 1);
  }

  const mouseOverHandler = (e) => {
    setShowTooltip(isEllipsisActive(e.target))
  }

  const child = <div onMouseOver={mouseOverHandler}>{component}</div>

  return showTooltip ?
    <OverlayTrigger placement="top" overlay={tooltip}>
      {child}
    </OverlayTrigger> : child
}

export default compose(
  withStateHandlers(
    {
      showTooltip: false
    },
    {
      setShowTooltip: () => (showTooltip) => ({
        showTooltip
      })
    }
  )
)(TooltipOnEllipsis);


// WEBPACK FOOTER //
// ./src/containers/components/tooltip-on-ellipsis.js